import { Field } from "formik";
const Locationcontent = (props) => {
  return (
    <>{props.showhidecomponent && 
      <div>
     
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                PHP POS Payments Merchant ID
              </label>
              <div className="col-md-9">
                <Field
                  type="text"
                  className="form-control"
                  // onChange={handleChange}
                  id="PHPPOSPayments"
                  name="PHPPOSPayments"
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Disable Amount Confirmation When Processing Credit Card
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="DisableAmountConfirmation"
                name="DisableAmountConfirmation"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                PHP POS Payments API Key
              </label>
              <div className="col-md-9">
                <Field
                  type="text"
                  className="form-control"
                  // onChange={handleChange}
                  id="PHPPOSPaymentsAPIKey"
                  name="PHPPOSPaymentsAPIKey"
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Use Integrated EBT
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="UseIntegratedEBT"
                name="UseIntegratedEBT"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                PHP POS Payments Bearer Token
              </label>
              <div className="col-md-9">
                <Field
                  type="text"
                  className="form-control"
                  // onChange={handleChange}
                  id="PHPPOSBearerToken"
                  name="PHPPOSBearerToken"
                />
              </div>
            </div>
          </div>{" "}
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                PHP POS Payments Signing Key
              </label>
              <div className="col-md-9">
                <Field
                  type="text"
                  className="form-control"
                  // onChange={handleChange}
                  id="PHPPOSSigningKey"
                  name="PHPPOSSigningKey"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Prompt For Loyalty
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="PromptForLoyalty"
                name="PromptForLoyalty"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Prompt For Name
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="PromptForName"
                name="PromptForName"
              />
            </div>
          </div>
          
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Prompt For E-Mail
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="PromptForEmail"
                name="PromptForEmail"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Prompt For Phone Number
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="PromptForPhone"
                name="PromptForPhone"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Terms & Conditions
              </label>
              <div className="col-md-9">
                <Field
                  as="textarea"
                  className="form-control"
                  // onChange={handleChange}
                  id="TermsConditions"
                  name="TermsConditions"
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Ask For Missing Information For Existing Customers
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="AskForMissingInformation"
                name="AskForMissingInformation"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Pre Work Order Authorization Terms
              </label>
              <div className="col-md-9">
                <Field
                  as="textarea"
                  className="form-control"
                  // onChange={handleChange}
                  id="PreworkorderAuthorizationTerms"
                  name="PreworkorderAuthorizationTerms"
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Post Work Order Terms
              </label>
              <div className="col-md-9">
                <Field
                  as="textarea"
                  className="form-control"
                  // onChange={handleChange}
                  id=" PostWorkOrderTerms"
                  name="PostWorkOrderTerms"
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                PHP POS Payments Test Mode
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="Phppostestmode"
                name="Phppostestmode"
              />
            </div>
          </div>
        </div>
        
      </div>}
    </>
  );
};
export default Locationcontent;
